const React = require("react")

const ThemeProvider = require('styled-components').ThemeProvider
const theme = require('./src/components/ui/theme').default
const Helmet = require('react-helmet').default

// You can delete this file if you're not using it

exports.wrapPageElement = ({ element, props }) => {
  return <ThemeProvider theme={theme}>
    { element }
  </ThemeProvider>
}
